export default (palette) => ({
  root: {
    backgroundColor: palette.background.paper, // Fundo sólido para as linhas darem destaque ao canvas! 💎🛡️⚡
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
    '&$selected': {
      backgroundColor: palette.type === 'dark' 
        ? 'rgba(255, 255, 255, 0.06)' 
        : 'rgba(10, 37, 64, 0.04)',
    },
    '&$hover': {
      '&:hover': {
        backgroundColor: palette.type === 'dark' 
          ? 'rgba(255, 255, 255, 0.04)' 
          : 'rgba(10, 37, 64, 0.02)',
        cursor: 'pointer',
      },
    },
  },
})
